/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateRoomCommandControllerCreate201,
  CreateRoomDto,
  ListRoomsQueryControllerListParams,
  NurseryRoomResponseDto,
  UpdateRoomCommandControllerUpdate200,
  UpdateRoomDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a nursery room
 */
export const createRoomCommandControllerCreate = (
  nurseryId: string,
  createRoomDto: CreateRoomDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateRoomCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/rooms`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createRoomDto,
    signal,
  });
};

export const getCreateRoomCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoomCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateRoomDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRoomCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateRoomDto },
  TContext
> => {
  const mutationKey = ["createRoomCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRoomCommandControllerCreate>>,
    { nurseryId: string; data: CreateRoomDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createRoomCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoomCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRoomCommandControllerCreate>>
>;
export type CreateRoomCommandControllerCreateMutationBody = CreateRoomDto;
export type CreateRoomCommandControllerCreateMutationError = void;

/**
 * @summary Create a nursery room
 */
export const useCreateRoomCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRoomCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateRoomDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRoomCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateRoomDto },
  TContext
> => {
  return useMutation(
    getCreateRoomCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all rooms for a nursery
 */
export const listRoomsQueryControllerList = (
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<NurseryRoomResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getListRoomsQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/rooms`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRoomsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRoomsQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRoomsQueryControllerList>>
  > = ({ signal }) => listRoomsQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRoomsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRoomsQueryControllerList>>
>;
export type ListRoomsQueryControllerListQueryError = void;

export function useListRoomsQueryControllerList<
  TData = Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListRoomsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listRoomsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRoomsQueryControllerList<
  TData = Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listRoomsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRoomsQueryControllerList<
  TData = Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all rooms for a nursery
 */

export function useListRoomsQueryControllerList<
  TData = Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListRoomsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoomsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListRoomsQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a nursery room
 */
export const updateRoomCommandControllerUpdate = (
  nurseryId: string,
  roomId: string,
  updateRoomDto: UpdateRoomDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateRoomCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/rooms/${roomId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateRoomDto,
    signal,
  });
};

export const getUpdateRoomCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>,
    TError,
    { nurseryId: string; roomId: string; data: UpdateRoomDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>,
  TError,
  { nurseryId: string; roomId: string; data: UpdateRoomDto },
  TContext
> => {
  const mutationKey = ["updateRoomCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>,
    { nurseryId: string; roomId: string; data: UpdateRoomDto }
  > = (props) => {
    const { nurseryId, roomId, data } = props ?? {};

    return updateRoomCommandControllerUpdate(nurseryId, roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoomCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>
>;
export type UpdateRoomCommandControllerUpdateMutationBody = UpdateRoomDto;
export type UpdateRoomCommandControllerUpdateMutationError = void;

/**
 * @summary Update a nursery room
 */
export const useUpdateRoomCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>,
      TError,
      { nurseryId: string; roomId: string; data: UpdateRoomDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRoomCommandControllerUpdate>>,
  TError,
  { nurseryId: string; roomId: string; data: UpdateRoomDto },
  TContext
> => {
  return useMutation(
    getUpdateRoomCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
